var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#E1DDD2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F453D",
  d: "M53.947 32.908H27.574l1.047-4.88h26.373zM28.93 31.817h24.13l.58-2.698H29.51zM52.32 40.495H25.945l1.047-4.88h26.373zM27.3 39.403h24.13l.58-2.697H27.882zM39.34 48.081H24.326l1.047-4.88h15.013zM25.681 46.99h12.769l.58-2.698H26.263z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1F453D",
  d: "m17.806 53.031 6.574-30.66h37.813l-4.585 21.406c.37.026.739.07 1.091.14l4.849-22.638H23.49l-7.04 32.843h32.032a9 9 0 0 1-.141-1.091z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F0A066",
  d: "M57.009 46.09c-3.503 0-6.345 2.82-6.345 6.295s2.842 6.295 6.345 6.295 6.344-2.82 6.344-6.295-2.842-6.294-6.344-6.294m2.921 7.78-1.205 1.196-1.716-1.703-1.716 1.703-1.206-1.197 1.716-1.702-1.716-1.702 1.206-1.196 1.716 1.702 1.716-1.702 1.205 1.196-1.716 1.702z"
})));
export { SvgErrorIllustration as ReactComponent };
export default __webpack_public_path__ + "3ec3bd19d323fa2d5042d6fb6dca4c2a.svg";